export default __webpack_public_path__ + "static/media/1.e4a5b15b.webp";